import { render, staticRenderFns } from "./lecZhuanlanList.vue?vue&type=template&id=280b9057&scoped=true"
import script from "./lecZhuanlanList.vue?vue&type=script&lang=js"
export * from "./lecZhuanlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b9057",
  null
  
)

export default component.exports